module.exports = ".table th, .table td {\r\n    border-top: 0px solid #eceeef;\r\n}\r\n.margin-set-left{\r\n    margin-left: 6px;\r\n}\r\n.margin-set-right{\r\n    margin-right: 6px;\r\n}\r\n.btn-mob-margin{\r\n    margin-top: 20px;\r\n}\r\n.card-text:first-of-type {\r\n    margin-top: 0em;\r\n}\r\n.card {\r\n    border: 1px solid rgba(0, 0, 0, 0.125);\r\n}\r\n.margin-top{\r\n    margin-top: 10px;\r\n}\r\n.margin-top-xs{\r\n    margin-top: 20px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/reference-document/upload-edit/upload-reference-document.component.css
// module id = ./src/app/modules/reference-document/upload-edit/upload-reference-document.component.css
// module chunks = main